import { render, staticRenderFns } from "./msw-free-software-trial.vue?vue&type=template&id=d1404f40&scoped=true&"
import script from "./msw-free-software-trial.vue?vue&type=script&lang=tsx&"
export * from "./msw-free-software-trial.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-free-software-trial.vue?vue&type=style&index=0&id=d1404f40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1404f40",
  null
  
)

export default component.exports